"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const sdk_1 = require("@hashgraph/sdk");
const deviceAccess_1 = require("../../hw/deviceAccess");
const network_1 = require("./api/network");
const utils_1 = require("./utils");
const hw_app_hedera_1 = __importDefault(require("./hw-app-hedera"));
const operation_1 = require("@ledgerhq/coin-framework/operation");
const signOperation = ({ account, transaction, deviceId }) => (0, deviceAccess_1.withDevice)(deviceId)(transport => {
    return new rxjs_1.Observable(o => {
        void (function () {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    o.next({
                        type: "device-signature-requested",
                    });
                    const hederaTransaction = yield (0, network_1.buildUnsignedTransaction)({
                        account,
                        transaction,
                    });
                    const accountPublicKey = sdk_1.PublicKey.fromString(account.seedIdentifier);
                    yield hederaTransaction.signWith(accountPublicKey, (bodyBytes) => __awaiter(this, void 0, void 0, function* () {
                        return yield new hw_app_hedera_1.default(transport).signTransaction(bodyBytes);
                    }));
                    o.next({
                        type: "device-signature-granted",
                    });
                    const operation = yield buildOptimisticOperation({
                        account,
                        transaction,
                    });
                    o.next({
                        type: "signed",
                        signedOperation: {
                            operation,
                            // NOTE: this needs to match the inverse operation in js-broadcast
                            signature: Buffer.from(hederaTransaction.toBytes()).toString("base64"),
                        },
                    });
                    o.complete();
                }
                catch (err) {
                    o.error(err);
                }
            });
        })();
    });
});
function buildOptimisticOperation({ account, transaction, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const operation = {
            id: (0, operation_1.encodeOperationId)(account.id, "", "OUT"),
            hash: "",
            type: "OUT",
            value: transaction.amount,
            fee: yield (0, utils_1.getEstimatedFees)(),
            blockHash: null,
            blockHeight: null,
            senders: [account.freshAddress.toString()],
            recipients: [transaction.recipient],
            accountId: account.id,
            date: new Date(),
            extra: {},
        };
        return operation;
    });
}
exports.default = signOperation;
//# sourceMappingURL=js-signOperation.js.map